import { combineReducers } from 'redux';

// internal
import { brand } from './brand';
import { project } from './project';
import { account } from './account';
import { zone } from './zone';
import { user } from './user';
import { permission } from './permission';
import { device } from './device';

const rootState = combineReducers({
  brand,
  project,
  account,
  zone,
  user,
  permission,
  device,
});

export default rootState;
